export default "__VITE_ASSET__C1ZuR2Xy__"